var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComments64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.196 19.501C25.392 12.575 32.53 7.5 41 7.5c10.217 0 18.5 7.387 18.5 16.5 0 5.934-3.513 11.137-8.785 14.045.635 1.874 1.434 3.42 2.398 4.637h0l.219.267.075.101a1 1 0 01-.903 1.543c-3.126-.201-5.886-1.649-8.28-4.343a20.816 20.816 0 01-3.42.25",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 7.5c10.217 0 18.5 7.387 18.5 16.5 0 5.934-3.513 11.137-8.785 14.045.635 1.874 1.434 3.42 2.398 4.637l.219.267.075.101a1 1 0 01-.903 1.543c-3.126-.201-5.886-1.649-8.28-4.343a20.816 20.816 0 01-3.42.25c.453-1.432.696-2.94.696-4.5 0-9.113-8.283-16.5-18.5-16.5l.196.001C25.392 12.575 32.53 7.5 41 7.5z",
    fillOpacity: 0.2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 19.5c10.217 0 18.5 7.387 18.5 16.5S33.217 52.5 23 52.5c-1.1 0-2.178-.086-3.225-.25-2.393 2.694-5.153 4.142-8.28 4.343a1 1 0 01-.827-1.644h0l.22-.267c.963-1.217 1.762-2.763 2.397-4.637C8.013 47.137 4.5 41.935 4.5 36c0-9.113 8.283-16.5 18.5-16.5z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments64);
export default __webpack_public_path__ + "static/media/comments-64.fe0f7e81.svg";
export { ForwardRef as ReactComponent };